export enum ENUM__ip_adapter_method {
  STYLE = 'style',
  COMPOSITION = 'composition',
  STYLE_PRECISE = 'style_precise',
  STYLE_STRONG = 'style_strong',
  FULL = 'full',
}
